import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6afff710"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dv-question-title" }
const _hoisted_2 = { style: {"display":"flex"} }
const _hoisted_3 = {
  key: 0,
  class: "dv-title-index"
}
const _hoisted_4 = {
  key: 1,
  class: "dv-title-score"
}
const _hoisted_5 = {
  key: 0,
  class: "question-correct_answer"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "correct_answer-title" }, "正确答案:", -1))
const _hoisted_7 = { class: "correct_answer-content" }
const _hoisted_8 = {
  key: 1,
  class: "question-analysis"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "analysis-title" }, "解析:", -1))
const _hoisted_10 = ["innerHTML"]

import _ from "lodash";
import {
  nextTick,
  onMounted,
  ref,
  defineComponent,
  createApp,
  reactive,
  computed,
  onBeforeUnmount,
} from "vue";
import UnderLineInput from "./UnderLineInput.vue";
import CustomAudio from "@/components/CustomAudio.vue";
import { unLock } from "@/utils/liner-lock";


export default /*#__PURE__*/_defineComponent({
  props: {
  question: {
    type: Object,
  },
  disabled: {
    type: Boolean,
  },
  showQuestionNum: {
    type: Boolean,
    default: true,
  },
  showQuestionScore: {
    type: Boolean,
    default: true,
  },
},
  setup(__props, { expose }) {

const props = __props


// 是否展示题号
const question = ref(props.question || {});
const answerData = reactive<any>({});

const answerDataInputValues = computed(() => {
  return Object.values(answerData || [])
    .map((value: any) => value.inputValue)
    .filter(Boolean);
});

const answerDataSpaces = computed(() => {
  return Object.values(answerData)
    .map((value: any) => {
      return { ...value, answer: value.inputValue };
    })
    .filter((answerData) => answerData.answer);
});

const isAnswerDataSame = computed(() => {
  const oldAnswers = (question.value.answer_params || {}).spaces || [];
  return oldAnswers.every((value: any) => {
    const { answer: oldAnswer, id } = value;
    const answer =
      answerDataSpaces.value.find((item: any) => item.id === id) || {};
    return answer == oldAnswer.answer;
  });
});

//* 获取答案

const getAnswer = () => {
  console.log("ererer", answerData);
  console.log("sdsdsd", answerDataInputValues.value);
  // console.log(isAnswerDataSame.value);
  if (!question.value.answer_params) {
    //* 没有回答过答案
    if (answerDataInputValues.value.filter(Boolean).length == 0) {
      //* 内容一样 代表没有碰过答案
      return { type: 0 };
    }
    return {
      type: 1,
      answer_params: {
        spaces: answerDataSpaces.value,
      },
    };
  } else {
    //* 回答过答案
    if (isAnswerDataSame.value) {
      //*  跟之前答过的一样
      return { type: 0 };
    }

    return {
      type: 1,
      answer_params: answerDataSpaces.value.length
        ? { spaces: answerDataSpaces.value }
        : undefined,
    };
  }
};

//*  编译title生成题目
const titleRef = ref<HTMLDivElement>();
let titleApp: any = null;

const transferAudio = (html: string) => {
  const audioExp = new RegExp("<kbd>.*?</kbd>", "g");
  const srcExp = new RegExp('src="([^"]+)');
  let match;
  let contentHtml = html;
  while ((match = audioExp.exec(html)) !== null) {
    contentHtml = contentHtml.replace(
      '<span style="color: rgb(159, 171, 183);">请点击按钮播放</span><span style="color: black;"> </span>',
      ""
    );
    const audioStr = match[0];
    const srcList: any = srcExp.exec(audioStr);
    const src = srcList?.length > 0 ? srcList[0] : "";
    const srcNum = src.replace(`src="`, "");
    const newStr = `<div class="dv-audio"><custom-audio musicUrl="${srcNum}"/></div>`;
    contentHtml = contentHtml.replace(audioStr, newStr);
  }
  return contentHtml;
};

const compileTitle = () => {
  const { title, question_params = {}, answer_params = {} } = question.value;
  if (!title) {
    return;
  }
  const fillsInData = (question_params.spaces || []).map((space: any) => {
    const answer =
      (answer_params.spaces || []).find(
        (aspace: { id: any }) => aspace.id === space.id
      ) || {};
    return _.merge({}, space, answer, {
      inputValue: answer.answer,
      oldType: space.type,
      type: space.type === 0 ? "input" : "select",
      disabled: props.disabled,
    });
  });

  console.log(fillsInData);

  fillsInData.forEach((data: any, index: number) => {
    answerData[`item${index}`] = {
      ...data,
      itemId: `item${index}`,
    };
  });
  console.log(answerData);

  const inputReg = new RegExp("<input.*?>", "g");

  const html = title || "";
  let template = title || "";
  let match;

  while ((match = inputReg.exec(html)) !== null) {
    const inputString = match[0] || "";
    let uuid = inputString.split("uuid=")[1];
    if (!uuid) {
      return;
    }
    uuid = uuid.slice(1, 17);
    const data: any = Object.values(answerData).find(
      (aData: any) => aData.id === uuid
    );
    const bindName = data.itemId;
    template = template.replace(
      inputString,
      `<UnderLineInput v-bind="${bindName}" v-model:inputValue="${bindName}.inputValue"></UnderLineInput>`
    );
  }
  template = transferAudio(template);
  console.log("title-template", template);
  const app = defineComponent({
    template,
    components: { UnderLineInput, CustomAudio },
    setup() {
      return answerData;
    },
  });
  titleApp = createApp(app);
  titleApp.mount(titleRef.value as HTMLDivElement);
};

const correctAnswerSpaces = computed(() => {
  return (question.value.question_params || {}).spaces || [];
});

expose({ getAnswer });

onMounted(async () => {
  await nextTick();
  compileTitle();
  unLock();
});
onBeforeUnmount(async () => {
  titleApp && (await titleApp.unmount());
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (props.showQuestionNum)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(question.value.indexInQuestion !== undefined
            ? question.value.indexInQuestion + "."
            : "") + _toDisplayString(question.value.titleNum > 0 ? question.value.titleNum : ""), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        id: "dvCompile56r6",
        class: "dv-title",
        ref_key: "titleRef",
        ref: titleRef
      }, null, 512),
      (props.showQuestionScore)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, " (" + _toDisplayString(question.value.score) + "分) ", 1))
        : _createCommentVNode("", true)
    ]),
    (props.disabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(correctAnswerSpaces), (space, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: space.id,
                class: "correct_answer_content_answer"
              }, " 第" + _toDisplayString(index + 1) + "空:" + _toDisplayString(space.correct_answer), 1))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (props.disabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", {
            class: "analysis-content",
            innerHTML: question.value?.analysis || ''
          }, null, 8, _hoisted_10)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})